











import { Component, Vue, Watch } from 'vue-property-decorator';
import { CheckoutStore, CheckoutState } from '@/store/checkoutstate';
import { ApiService } from '@/services/ApiService';

@Component
export default class CartItemsCount extends Vue {
    private body: HTMLElement | null = document.querySelector('#body');
    get cart() {
        return CheckoutStore.cart;
    }

    get quantity() {
        return Number(this.cart.quantity) || 0;
    }

    constructor() {
        super();
    }
    protected created() {
        ApiService.getMiniCart().then(response => {
            if (response && response.data) {
                const payload: CheckoutState = {
                    cart: response.data
                };
                CheckoutStore.saveState(payload).then(() => {
                    /*nothing*/
                });
            }
        });
    }

    @Watch('cart')
    onCartChanged(val: any, oVal: any) {
        // console.log('cart changed', val, oVal);
        if (this.body !== null) {
            if (val.quantity !== '0') {
                if (!this.body.classList.contains('sticky')) {
                    this.body.classList.add('sticky');
                }
            } else {
                if (this.body.classList.contains('sticky')) {
                    this.body.classList.remove('sticky');
                }
            }
        }
    }
}
